export const outletsRemovePluginRequest_v1_schema = {
  type: 'object',
  properties: {
    target: {
      type: 'string',
    },
  },
  required: ['target'],
};
